module.exports = __webpack_public_path__ + "static/media/33-2.93803528.mp3";